/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_CapturedInputs */

const en_us2_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done, photo taken.`)
};

const pt_br2_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto, foto tirada.`)
};

const es_419_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo, foto tomada.`)
};

const pt_pt2_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto, foto tirada.`)
};

const fr_fr2_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est bon, photo prise.`)
};

const de_de2_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig, Foto gemacht.`)
};

const it_it2_body_assessment_cue_captured = /** @type {(inputs: Body_Assessment_Cue_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto, foto scattata.`)
};

/**
* | output |
* | --- |
* | "Done, photo taken." |
*
* @param {Body_Assessment_Cue_CapturedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_captured = /** @type {((inputs?: Body_Assessment_Cue_CapturedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_CapturedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_captured(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_captured(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_captured(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_captured(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_captured(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_captured(inputs)
	return en_us2_body_assessment_cue_captured(inputs)
});
export { body_assessment_cue_captured as "body-assessment.cue.captured" }